import React from "react";
import "./landingHeader.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

function LandingHeader() {
  const navigate = useNavigate();

  return (
    <div className="nav-container">
      <div className="name-brand" onClick={() => navigate("/")}>
        <span className="blue">app.speqqle</span>
        <span className="black"></span>
      </div>
      <div className="nav-menu">
        <p className="clikable" onClick={() => navigate("/functions-landing")}>
          Functions
        </p>
        <p
          className="clikable"
          onClick={() => navigate("/applications-landing")}
        >
          Applications
        </p>
        <p className="clikable" onClick={() => navigate("/prices-landing")}>
          Prices
        </p>
        <button className="btn btn-login" onClick={() => navigate("/login")}>
          Login
        </button>
      </div>
    </div>
  );
}

export default LandingHeader;
